// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/common/v1/errors.proto (package thru.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/common/v1/errors.proto.
 */
export const file_thru_common_v1_errors: GenFile = /*@__PURE__*/
  fileDesc("Cht0aHJ1L2NvbW1vbi92MS9lcnJvcnMucHJvdG8SDnRocnUuY29tbW9uLnYxIq4CCgtFcnJvckRldGFpbBIyCgplcnJvcl90eXBlGAEgASgOMhkudGhydS5jb21tb24udjEuRXJyb3JUeXBlQgPgQQISHAoHbWVzc2FnZRgCIAEoCUIL4EECukgFcgMYgAgSKAoWcmV0ZW50aW9uX3dpbmRvd19zbG90cxgDIAEoBEID4EEBSACIAQESPgoQcmV0ZW50aW9uX2N1dG9mZhgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCA+BBAUgBiAEBEiQKCmZpZWxkX25hbWUYBSABKAlCC+BBAbpIBXIDGIABSAKIAQFCGQoXX3JldGVudGlvbl93aW5kb3dfc2xvdHNCEwoRX3JldGVudGlvbl9jdXRvZmZCDQoLX2ZpZWxkX25hbWUq7QEKCUVycm9yVHlwZRIaChZFUlJPUl9UWVBFX1VOU1BFQ0lGSUVEEAASGAoURVJST1JfVFlQRV9OT1RfRk9VTkQQARIbChdFUlJPUl9UWVBFX05PVF9SRVRBSU5FRBACEigKJEVSUk9SX1RZUEVfTk9UX0ZPVU5EX09SX05PVF9SRVRBSU5FRBADEh4KGkVSUk9SX1RZUEVfSU5WQUxJRF9SRVFVRVNUEAQSJAogRVJST1JfVFlQRV9DRUxfVkFMSURBVElPTl9GQUlMRUQQBRIdChlFUlJPUl9UWVBFX0lOVEVSTkFMX0VSUk9SEAZCxwEKEmNvbS50aHJ1LmNvbW1vbi52MUILRXJyb3JzUHJvdG9QAVpEZ2l0aHViLmNvbS9VbnRvLUxhYnMvdGhydS1uZXQvZ3JwYy9wa2cvcHJvdG8vdGhydS9jb21tb24vdjE7Y29tbW9udjGiAgNUQ1iqAg5UaHJ1LkNvbW1vbi5WMboCA1RIVcoCDlRocnVcQ29tbW9uXFYx4gIaVGhydVxDb21tb25cVjFcR1BCTWV0YWRhdGHqAhBUaHJ1OjpDb21tb246OlYxYgZwcm90bzM", [file_buf_validate_validate, file_google_api_field_behavior, file_google_protobuf_timestamp]);

/**
 * ErrorDetail provides structured error metadata attached to gRPC errors.
 *
 * @generated from message thru.common.v1.ErrorDetail
 */
export type ErrorDetail = Message<"thru.common.v1.ErrorDetail"> & {
  /**
   * High-level error category.
   *
   * @generated from field: thru.common.v1.ErrorType error_type = 1;
   */
  errorType: ErrorType;

  /**
   * Human-readable error summary.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Optional retention window expressed in slots when applicable.
   *
   * @generated from field: optional uint64 retention_window_slots = 3;
   */
  retentionWindowSlots?: bigint | undefined;

  /**
   * Optional retention cutoff timestamp when applicable.
   *
   * @generated from field: optional google.protobuf.Timestamp retention_cutoff = 4;
   */
  retentionCutoff?: Timestamp | undefined;

  /**
   * Optional name of the field associated with the error.
   *
   * @generated from field: optional string field_name = 5;
   */
  fieldName?: string | undefined;
};

/**
 * Describes the message thru.common.v1.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_errors, 0);

/**
 * ErrorType captures structured error categories returned by the services.
 *
 * @generated from enum thru.common.v1.ErrorType
 */
export enum ErrorType {
  /**
   * ERROR_TYPE_UNSPECIFIED is an unknown error condition.
   *
   * @generated from enum value: ERROR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ERROR_TYPE_NOT_FOUND indicates requested data does not exist.
   *
   * @generated from enum value: ERROR_TYPE_NOT_FOUND = 1;
   */
  NOT_FOUND = 1,

  /**
   * ERROR_TYPE_NOT_RETAINED indicates requested data was not retained under TTL.
   *
   * @generated from enum value: ERROR_TYPE_NOT_RETAINED = 2;
   */
  NOT_RETAINED = 2,

  /**
   * ERROR_TYPE_NOT_FOUND_OR_NOT_RETAINED indicates an ambiguous not found vs TTL case.
   *
   * @generated from enum value: ERROR_TYPE_NOT_FOUND_OR_NOT_RETAINED = 3;
   */
  NOT_FOUND_OR_NOT_RETAINED = 3,

  /**
   * ERROR_TYPE_INVALID_REQUEST indicates the request failed validation.
   *
   * @generated from enum value: ERROR_TYPE_INVALID_REQUEST = 4;
   */
  INVALID_REQUEST = 4,

  /**
   * ERROR_TYPE_CEL_VALIDATION_FAILED indicates a CEL filter failed validation.
   *
   * @generated from enum value: ERROR_TYPE_CEL_VALIDATION_FAILED = 5;
   */
  CEL_VALIDATION_FAILED = 5,

  /**
   * ERROR_TYPE_INTERNAL_ERROR indicates an internal server error occurred.
   *
   * @generated from enum value: ERROR_TYPE_INTERNAL_ERROR = 6;
   */
  INTERNAL_ERROR = 6,
}

/**
 * Describes the enum thru.common.v1.ErrorType.
 */
export const ErrorTypeSchema: GenEnum<ErrorType> = /*@__PURE__*/
  enumDesc(file_thru_common_v1_errors, 0);

